module.exports = __webpack_public_path__ + "static/media/glowco_2_criss cross top in plum.6e9bb16d.jpeg";